declare var dataLayer: any;

export default {
  productClick(obj: object, list: string, cb: Function) {
    dataLayer.push({
      event: 'productClick',
      ecommerce: {
        click: {
          actionField: { list },
          products: [
            obj,
          ],
        },
      },
      eventCallback: typeof cb !== 'undefined' ? cb : () => {},
    });
  },

  addProduct(obj: object, cb: Function) {
    const arr: any[] = Array.isArray(obj) ? obj : [obj];

    dataLayer.push({
      event: 'addToCart',
      ecommerce: {
        add: {
          products: arr,
        },
      },
      eventCallback: typeof cb !== 'undefined' ? cb : () => {},
    });
  },

  removeProduct(obj: object, cb: Function) {
    dataLayer.push({
      event: 'removeFromCart',
      ecommerce: {
        remove: {
          products: [
            obj,
          ],
        },
      },
      eventCallback: typeof cb !== 'undefined' ? cb : () => {},
    });
  },

  // checkoutOption(option, currentStep) {
  //   dataLayer.push({
  //     event: 'checkoutOption',
  //     ecommerce: {
  //       checkout_option: {
  //         actionField: {
  //           step: currentStep,
  //           option,
  //         },
  //       },
  //     },
  //   });
  // },

  event(
    category: string,
    action: string = '(not set)',
    label: string = '(not set)',
    value: string = '(not set)'
  ) {
    dataLayer.push({
      event: 'general_event',
      general_event_category: category,
      general_event_action: action,
      general_event_label: label,
      general_event_value: value,
    });
  },

  timing(naming: string, value: string|number) {
    dataLayer.push({
      event: 'timing',
      timing_name: naming,
      timing_value: value,
    });
  },
};
